const MandalaWatermark = ({ className = "", style }) => (
  <svg
    viewBox="0 0 800 800"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    aria-hidden="true"
  >
    <g opacity="1" stroke="currentColor" strokeWidth="0.8">
      {/* Concentric circles */}
      <circle cx="400" cy="400" r="380" />
      <circle cx="400" cy="400" r="320" />
      <circle cx="400" cy="400" r="260" />
      <circle cx="400" cy="400" r="200" />
      <circle cx="400" cy="400" r="140" />
      <circle cx="400" cy="400" r="80" />

      {/* Petal layers - outer */}
      {Array.from({ length: 16 }).map((_, i) => {
        const angle = (i * 360) / 16;
        const rad = (angle * Math.PI) / 180;
        const x1 = 400 + 260 * Math.cos(rad);
        const y1 = 400 + 260 * Math.sin(rad);
        const x2 = 400 + 380 * Math.cos(rad);
        const y2 = 400 + 380 * Math.sin(rad);
        return <line key={`outer-${i}`} x1={x1} y1={y1} x2={x2} y2={y2} />;
      })}

      {/* Petal layers - mid */}
      {Array.from({ length: 12 }).map((_, i) => {
        const angle = (i * 360) / 12;
        const rad = (angle * Math.PI) / 180;
        const cx = 400 + 230 * Math.cos(rad);
        const cy = 400 + 230 * Math.sin(rad);
        return <circle key={`mid-${i}`} cx={cx} cy={cy} r="18" />;
      })}

      {/* Inner petals */}
      {Array.from({ length: 8 }).map((_, i) => {
        const angle = (i * 360) / 8;
        const rad = (angle * Math.PI) / 180;
        const nextRad = ((angle + 45) * Math.PI) / 180;
        const x1 = 400 + 80 * Math.cos(rad);
        const y1 = 400 + 80 * Math.sin(rad);
        const cpx = 400 + 160 * Math.cos((rad + nextRad) / 2);
        const cpy = 400 + 160 * Math.sin((rad + nextRad) / 2);
        const x2 = 400 + 80 * Math.cos(nextRad);
        const y2 = 400 + 80 * Math.sin(nextRad);
        return (
          <path
            key={`petal-${i}`}
            d={`M ${x1} ${y1} Q ${cpx} ${cpy} ${x2} ${y2}`}
          />
        );
      })}

      {/* Lotus-style arcs between mid and outer */}
      {Array.from({ length: 16 }).map((_, i) => {
        const angle = (i * 360) / 16 + 11.25;
        const rad = (angle * Math.PI) / 180;
        const x1 = 400 + 140 * Math.cos(rad);
        const y1 = 400 + 140 * Math.sin(rad);
        const x2 = 400 + 200 * Math.cos(rad);
        const y2 = 400 + 200 * Math.sin(rad);
        return <line key={`inner-line-${i}`} x1={x1} y1={y1} x2={x2} y2={y2} />;
      })}

      {/* Center dot */}
      <circle cx="400" cy="400" r="6" fill="currentColor" />
    </g>
  </svg>
);

export default MandalaWatermark;
